export default "__VITE_ASSET__DX3ePtp4__"